import { useCallback } from "react";

import { FormGroup, Colors } from "@blueprintjs/core";

import { Box, Flex } from "@/components/layout/flexbox";
import {
  state,
  action,
} from "@/components/pages_logged_in/roleplays/details/scenario/edit/useEditScenario";
import { Tiptap } from "@/components/pieces/editor/tiptap";
import { SUBTEXT_COLOR } from "@/css/constants";
import { uploadFile } from "@/lib/upload-file";

export function ScenarioTab({
  state,
  dispatch,
}: {
  state: state;
  dispatch: (action: action) => void;
}) {
  const handleContextChange = useCallback(
    (value: string) => {
      dispatch({ type: "setContext", context: value });
    },
    [dispatch],
  );

  const handleObjectiveChange = useCallback(
    (value: string) => {
      dispatch({ type: "setObjective", objective: value });
    },
    [dispatch],
  );

  return (
    <Flex
      flexDirection="column"
      p={24}
      pb={12}
      className="flex-auto bg-blue-50"
    >
      <FormGroup
        label={
          <Box fontSize={18} mb={1} fontWeight={600}>
            Scenario Context
          </Box>
        }
        labelInfo={
          <Box fontSize={14} fontWeight={400} color={SUBTEXT_COLOR}>
            What learners see before the conversation begins
          </Box>
        }
      >
        <Flex mt={2} backgroundColor={Colors.WHITE} className="round-corners">
          <Tiptap
            content={state.context ?? ""}
            onChange={handleContextChange}
            onFileUpload={uploadFile}
          />
        </Flex>
      </FormGroup>
      <FormGroup
        label={
          <Box fontSize={18} mb={1} fontWeight={600}>
            Scenario Objective
          </Box>
        }
        labelInfo={
          <Box fontSize={14} fontWeight={400} color={SUBTEXT_COLOR}>
            Define what the learner should accomplish in this conversation and
            any outcomes they should avoid.
          </Box>
        }
      >
        <Flex mt={2} backgroundColor={Colors.WHITE} className="round-corners">
          <Tiptap
            content={state.objective ?? ""}
            onChange={handleObjectiveChange}
            onFileUpload={uploadFile}
          />
        </Flex>
      </FormGroup>
    </Flex>
  );
}
